import { render, staticRenderFns } from "./PluralWord.vue?vue&type=template&id=6dddc6dc&scoped=true"
import script from "./PluralWord.vue?vue&type=script&lang=js"
export * from "./PluralWord.vue?vue&type=script&lang=js"
import style0 from "./PluralWord.vue?vue&type=style&index=0&id=6dddc6dc&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dddc6dc",
  null
  
)

export default component.exports